export const getTargetDateString = (dayOffset: number): string => {
  const targetDate = new Date()
  targetDate.setDate(targetDate.getDate() + dayOffset)
  return targetDate.toDateString()
}
